import styles from './RowCheckbox.module.less';

type RowCheckboxProps = {
  isSelected: boolean,
};

const RowCheckbox = ({ isSelected }: RowCheckboxProps) =>
  <span className={styles.checkbox}>
    <input type="checkbox" checked={isSelected} />
  </span>;

export default RowCheckbox;
